import { Component, Input } from '@angular/core';

import { IconMode } from '../../../icon/icon.component';
import { ButtonMode, ButtonSize } from '../../../button/button.component';
import { LayoutNavItem, LayoutNavItemDivider } from '../../layout.interface';
import { DropdownPlacement } from '../../../dropdown/dropdown.directive';

@Component({
  selector: 'uex-layout-header-menu',
  templateUrl: './menu.component.html'
})
export class LayoutHeaderMenuComponent {
  @Input('iconName') public iconName = 'person';
  @Input('iconMode') public iconMode: IconMode = 'md';
  @Input('iconColor') public iconColor = 'white';
  @Input('iconSize') public iconSize: string = null;

  @Input('buttonMode') public buttonMode: ButtonMode = 'fab';
  @Input('buttonColor') public buttonColor = 'primary';
  @Input('buttonSize') public buttonSize: ButtonSize = 'default';

  @Input('dropdownPlacement') public dropdownPlacement: DropdownPlacement = 'bottom-end';

  @Input('items') public items: Array<LayoutNavItem | LayoutNavItemDivider> = [];

  constructor() { }
}
